
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import { DatePicker } from '../../components/shared/DatePicker';
import { useTextResources } from '../../language';
import { isMobileOnly } from 'mobile-device-detect';
import PropTypes from 'prop-types';
import WeekDaysSelect from '../../components/shared/WeekDaysSelect';
import RoomTypesDropDown from '../../components/shared/RoomTypesDropDown';
import NumericInput from '../../components/shared/NumericInput';
import moment from 'moment';
import { Availability } from '../../api/services/next';
import { onError, onSuccess, onWarning } from '../../components/shared/messages';
import { PermissionsActions, UserHasPermission } from '../../components/shared/permissionsActions';

export const EditMaxOccupancyPopup = ({ edit, setEdit, onSave }) => {
    const text = useTextResources();
    const [dates, setDates] = useState([moment().toDate(), moment().toDate()]);
    const [days, setDays] = useState(null);
    const [roomTypes, setRoomTypes] = useState([]);
    const [maxOccupancy, setMaxOccupancy] = useState(0);

    useEffect(() => {
        if (edit && !UserHasPermission(PermissionsActions.EditMaxPax)) {
            onWarning(text('NoPermission'));
            setEdit(false);
        }
    }, [edit]);

    const setStartDate = (date) => {
        setDates([date, dates[1]]);
    }
    const setEndDate = (date) => {
        setDates([dates[0], date]);
    }

    const saveAction = async (close) => {
        // Save action here
        try {
            await Availability.UpdateMaxOccupancy({
                StartDate: dates[0],
                EndDate: dates[1],
                Weekdays: days.reduce((acc, d) => acc | (1 << d), 0),
                RoomTypeIds: roomTypes,
                MaxOccupancy: maxOccupancy
            });
            setEdit(!close);
            onSave?.();
            onSuccess();
        } catch (error) {
            onError(error);
        }
    }

    const weekdates = React.useMemo(() => {
        return [{ startDate: dates[0], endDate: dates[1] }]
    }, [dates])


    return <Modal size="small" open={edit} onClose={() => setEdit(false)} >
        <Modal.Header>{text('Edit')}</Modal.Header>
        <Modal.Content style={
            isMobileOnly
                ? { overflowY: 'auto' }
                : { maxHeight: 600, minHeight: 500, overflowY: 'auto' }
        }>
            <Form>
                <Form.Group>
                    <Form.Field>
                        <label>{text('FromDate')}</label>
                        <DatePicker type='basic' onChange={setStartDate} value={dates[0]} />
                    </Form.Field>
                    <Form.Field>
                        <label>{text('ToDate')}</label>
                        <DatePicker type='basic' onChange={setEndDate} value={dates[1]} />
                    </Form.Field>
                </Form.Group>
                <Form.Field
                    label={text('Weekdays')}
                    control={WeekDaysSelect}
                    onChange={setDays}
                    dates={weekdates}
                />
                <Form.Group>
                    <Form.Field
                        width={12}
                        label={text('RoomType')}
                        clearable
                        multiple
                        placeholder={text("All")}
                        control={RoomTypesDropDown}
                        onChange={setRoomTypes}
                        value={roomTypes}
                    />
                    <Form.Field
                        label={text('Maximum') + " " + text('StayOver')}
                        control={NumericInput}
                        value={maxOccupancy}
                        onChange={(value) => setMaxOccupancy(parseInt(value))}
                        min={0}
                        digits={0}
                    />
                </Form.Group>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button negative onClick={() => setEdit(false)}>{text('Close')}</Button>
            <Button positive onClick={() => saveAction(true)}>{text('Saveandclose')}</Button>
            <Button positive onClick={() => saveAction(false)}>{text('Save')}</Button>
        </Modal.Actions>
    </Modal>
}



EditMaxOccupancyPopup.propTypes = {
    edit: PropTypes.bool,
    setEdit: PropTypes.func,
    onSave: PropTypes.func
}
